module.exports = __webpack_public_path__ + "static/media/V9.aec8bd82.mp4";